import type { NotificationPlacement } from '@app/services/notificationService/types'

export const NOTIFICATION_PLACEMENT: Record<string, NotificationPlacement> = {
  top: 'top',
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight'
}
